const state = {
  listaArquivosAssinados: [],
  arquivoAssinadoBlobURL: null,
  arquivoAssinadoInsercaoDialog: false,
  listaTiposAssinatura: []
}

export default state
